import { Component, inject } from '@angular/core';
import { CancellationFlowHistoryEntry } from 'src/app/_types/cancellation.types';
import { ExpansionPanelComponent } from 'src/app/shared/ui-kit/expansion-panel/expansion-panel.component';

import { CancellationDetailsService } from './cancellation-details.service';
import { CancellationLogTableComponent } from './cancellation-log-table.component';

/** « Logs »: the cancellation's own timeline, which arrives with the details. */
@Component({
  selector: 'app-cancellation-log',
  standalone: true,
  imports: [ExpansionPanelComponent, CancellationLogTableComponent],
  template: `
    <app-expansion-panel title="Logs" i18n-title>
      @if (entries.length) {
        <app-cancellation-log-table class="d-block mt-12" [entries]="entries" />
      } @else {
        <div class="mt-16 text-muted text-center" i18n>
          Aucun log à afficher
        </div>
      }
    </app-expansion-panel>
  `,
  styles: `
    :host {
      display: block;
      width: 100%;
    }
  `,
})
export class CancellationLogComponent {
  private readonly detailsService = inject(CancellationDetailsService);

  protected get entries(): CancellationFlowHistoryEntry[] {
    return this.detailsService.state.details?.timeline ?? [];
  }
}
